import { render, staticRenderFns } from "./DedicatedNumberPaymentNotification.vue?vue&type=template&id=649c3142&scoped=true&"
import script from "./DedicatedNumberPaymentNotification.vue?vue&type=script&lang=js&"
export * from "./DedicatedNumberPaymentNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c3142",
  null
  
)

export default component.exports